import { useState } from "react";
import Navigation from "../../navigation/components/Navigation";
import LandingPage from "./LandingPage";

const CreateAccount = () => {
  const [loginForm, setShowLoginForm] = useState(false);

  return (
    <div className="login">
      <Navigation setShowLoginForm={setShowLoginForm} />
      <div className="login-container">
        <LandingPage
          loginForm={loginForm}
          setShowLoginForm={setShowLoginForm}
        />
      </div>
    </div>
  );
};

export default CreateAccount;
